module.exports = __webpack_public_path__ + "img/chevron_right_nav_link.46d658e4.svg";